export default {
}



// WEBPACK FOOTER //
// ./src/app/tenant/common-area/resources/components.js